import { Paragraph, CardName } from 'library/styles/text';
import {
  useCallback,
} from 'react';
import useImageSource from 'library/hooks/use-image-source';
import getImage from 'library/helpers/get-thumbnail-image-source';

import {
  Container,
  ImageWrapper,
  Image,
  ImageOverlay,
  Icon,
} from './styles';

function ItemGrid({
  item,
  isSelected,
  isOpened,
  onOpen,
  onSelect,
  // height,
}) {
  const { src, height: loadHeight, width: loadWidth } = useImageSource(item?.images?.[0] || {}, 160);
  const handleOpen = useCallback(() => {
    onOpen(item.id);
  }, [item?.id]);

  return (
    <Container
      isSelected={item.isDeleted ? false : isSelected}
      isOpened={isOpened}
      onClick={item.isDeleted ? undefined : handleOpen}
      isDeleted={item.isDeleted}
      isLoaded={!!src}
    >
      <ImageWrapper>
        <Image
          alt={item.name}
          src={src}
          // width={160}
          height={loadHeight}
          width={loadWidth}
          // maxWidth={160}
        />
        <ImageOverlay>
          <Icon className="icon-check-inverse" onClick={onSelect} />
          {/* <Icon className="icon-options-vertical" /> */}
        </ImageOverlay>
      </ImageWrapper>
      <CardName>{item.name}</CardName>
      <Paragraph isVisible>{item.category_name}</Paragraph>
      <Paragraph isVisible>{item.manufacturer_name}</Paragraph>
    </Container>
  );
}

export default ItemGrid;
